import { useEffect } from "react";
import analyticsInstance from "../services/analytics-instance";

/**
 * Get GA custom context from sessionStorage
 * This context is set by the authentication flow
 */
const getGaCustomContext = (): Record<string, unknown> | undefined => {
  const storage = (globalThis as { sessionStorage?: Storage }).sessionStorage;

  if (!storage) {
    return undefined;
  }

  try {
    const stored = storage.getItem("ga-custom-context");
    return stored ? JSON.parse(stored) : undefined;
  } catch (error) {
    console.warn("Unable to read GA custom context from session storage:", error);
    return undefined;
  }
};

/**
 * Component to initialize Google Analytics at the root level
 * Similar to InitAuth, InitMedallia, etc.
 */
const InitAnalytics: React.FC = () => {
  useEffect(() => {
    const initGA = async () => {
      try {
        const measurementId =
          process.env.REACT_APP_GA_MEASUREMENT_ID ??
          process.env.REACT_APP_GA_TRACKING_ID;
        const customContext = getGaCustomContext();

        await analyticsInstance.initialize(measurementId, customContext);
      } catch (error) {
        console.error("Failed to initialize Google Analytics:", error);
      }
    };

    initGA().catch((error) => {
      console.error("Failed to initialize Google Analytics:", error);
    });
  }, []);

  return null;
};

export default InitAnalytics;
